export default __webpack_public_path__ + "static/media/icon-location.dcbbed55.svg";